export default __webpack_public_path__ + "static/media/terminate-3.f23be3a0.png";